/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { IconLaunch } from '@src/common/MaterialIcon/IconLaunch';
import { styled } from '@uhg-abyss/web/tools/styled';
import { PageLayout } from '@src/common/PageLayout';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { useStandardUserRegistration } from '@src/state/SURegistration';
import { useUser } from '@src/state/user';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useTIN } from '@src/state/taxInformation';
import { FLOW_ID } from '@src/common/AppConstants';
import { event as adobeTaggingEvent } from '@uhg-abyss/web/tools/event';
import { useOnloading } from '@src/state/landing';
import { getOrgType } from '@src/common/helpers';
import { useFormState } from '@src/state/form/hooks';
import { updateAccountInfo } from '@src/state/form/actions';
import { LagoonContext } from '@src/AppContext/LagoonContext';
import { setPageHandler } from '@src/common/tools/analytics/helpers';

const HeaderName = styled('h1', {
  fontSize: '24px',
  fontWeight: 600,
  paddingTop: '20px',
  textAlign: 'left',
  fontFamily: '$heading',
  color: '$primary1',
  marginBottom: '6px',
});

const SubheaderName = styled('p', {
  fontSize: '20px',
  fontWeight: 'bold',
  paddingTop: '25px',
  textAlign: 'left',
  color: '$primary1',
  marginBottom: '3px',
});

const DetailContainer = styled('p', {
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: '5px',
  marginBottom: '0px',
});

const TaskAccessDetailContainer = styled('p', {
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: '5px',
});

const NameAndNumber = styled('p', {
  paddingTop: '5px',
  display: 'block',
});

const EmailAndJobFunction = styled('p', {
  paddingTop: '5px',
});

const TitleHeader = styled('p', {
  marginRight: '150px',
  textAlign: 'left',
  fontFamily: '$primary',
  marginBottom: '0px !important',
  display: 'block',
});

const Name = styled('span', {
  marginRight: '150px',
  fontWeight: 700,
  textAlign: 'left',
  fontFamily: '$primary',
  marginBottom: '0px !important',
});

const SecondaryTitleHeader = styled('span', {
  marginRight: '150px',
  textAlign: 'left',
  marginTop: '20px',
  fontFamily: '$primary',
  marginBottom: '0px !important',
  display: 'block',
});

const EmailPhoneAndJob = styled('p', {
  display: 'inlineBlock',
  flexDirection: 'column',
  fontWeight: 700,
  textAlign: 'left',
  fontFamily: '$primary',
  marginBottom: '0px !important',
});

const Email = styled('p', {
  marginRight: '5px',
  fontWeight: 700,
  textAlign: 'left',
  fontFamily: '$primary',
  marginBottom: '0px !important',
});

const NumberHeader = styled('p', {
  marginRight: '150px',
  textAlign: 'left',
  marginTop: '20px',
  fontFamily: '$primary',
  marginBottom: '0px !important',
  width: '100%',
});

const PagelayoutContainer = {
  marginRight: '0px',
  marginTop: '25px',
};

const Container = {
  border: '1px solid rgb(219, 219, 219)',
  backgroundColor: 'white',
  padding: '0px 35px 0px 35px',
};

const AccountInformation = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  borderBottom: 'solid 0.5px lightgray',
};

const ButtonView = styled('div', {
  display: 'flex',
  margin: 'auto',
  marginTop: '15px',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

const BackButton = styled('div', {
  width: '115px',
  padding: '6px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  borderWidth: '2.5px',
  border: '2px solid $primary1',
  background: '$white',
  borderStyle: 'solid',
  borderRadius: '23px',
  marginTop: 'auto',
  marginBottom: '20px',
  alignItems: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
});

const BackButtonText = styled('span', {
  color: '$primary1',
  fontWeight: 'bold',
  marginLeft: '12px',
  fontSize: '16px',
});

const NextButton = styled('div', {
  width: '115px',
  padding: '6px',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  borderWidth: '2.5px',
  border: '2px solid $primary1',
  background: '$primary1',
  borderStyle: 'solid',
  borderRadius: '23px',
  marginTop: 'auto',
  marginBottom: '20px',
  alignItems: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
});

const NextButtonText = styled('span', {
  color: '$white',
  fontWeight: 'bold',
  marginRight: '12px',
  fontSize: '16px',
});

const ModalButton = styled('div', {
  color: 'black !important',
  backgroundColor: 'black !important',
  width: '170px !important',
  height: '170px !important',
  fontWeight: 'bold',
  marginRight: '12px',
  fontSize: '16px',
});

const FlyoutCloseButton = styled('div', {
  marginBottom: '15px',
  marginLeft: '-5px',
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'none',
  },
});

const ModalHeaderName = styled('h1', {
  fontSize: '26px',
  fontWeight: 600,
  textAlign: 'left',
  fontFamily: '$heading',
  color: '$primary1',
  marginBottom: '6px',
  marginTop: '-20px',
});

const ModalContainer = {
  height: '180px',
  width: '470px',
  border: '.5px',
  borderRadius: '2px',
  backgroundColor: 'white',
  padding: '0px 35px 0px 35px',
};

const ModalButtonView = styled('div', {
  display: 'flex',
  margin: 'auto',
  marginTop: '15px',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

const ModalBackButton = styled('div', {
  width: '122px',
  padding: '6px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  borderWidth: '2.5px',
  border: '2px solid $primary1',
  background: '$white',
  borderStyle: 'solid',
  borderRadius: '23px',
  marginTop: 'auto',
  marginBottom: '20px',
  alignItems: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
});

const ModalBackButtonText = styled('span', {
  color: '$primary1',
  fontWeight: 'bold',
  marginLeft: '12px',
  fontSize: '16px',
});

const ModalNextButton = styled('div', {
  width: '122px',
  padding: '6px',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  borderWidth: '2.5px',
  border: '2px solid $primary1',
  background: '$primary1',
  borderStyle: 'solid',
  borderRadius: '23px',
  marginTop: 'auto',
  marginBottom: '20px',
  alignItems: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
});

const ModalNextButtonText = styled('span', {
  color: '$white',
  fontWeight: 'bold',
  marginRight: '12px',
  fontSize: '16px',
});

const Content = styled('span', {
  textAlign: 'left',
  fontSize: '16px',
});

const List = styled('ul', {
  'list-style': 'none',
});

const ListItem = styled('li', {
  'list-style-type': 'none',
  fontWeight: 'bold',
});

const ListReporting = styled('ul', {
  'list-style': 'disc',
  paddingLeft: '25px',
});

const ListItemReporting = styled('li', {
  'list-style-type': 'disc',
  fontWeight: 'bold',
});

const TaskAccessContainer = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  paddingTop: '5px',
});

const Ext = styled('span', {
  fontWeight: 'normal',
  marginLeft: '5px',
});

export const SUReviewAndConfirm = ({
  handleEdit,
  handleConfirm,
  handleBack,
}) => {
  const { token } = useParams();
  const { currentFlow } = useOnloading.state();
  const isProviderFlow = currentFlow === FLOW_ID.PROVIDER;
  const isSUFlow = currentFlow === FLOW_ID.API_MARKETPLACE_PROVIDER_TECHNICIAN;

  const lagoonContext = React.useContext(LagoonContext);
  const featureToggles = lagoonContext.getTable('feature-toggles');
  const [flyoutModalOpen, setFlyoutModalOpen] = useState(false);
  const { changeCurrentStep } = useStandardUserRegistration.actions();
  const {
    selectedPermissions,
    selectedJobFunctions,
    phone,
    phoneExt,
    selectedAdmin,
  } = useStandardUserRegistration.state();
  const { TINInfo, TINNumber } = useTIN.state();
  const { userUUID } = useUser.state();
  const { firstName, lastName, email } = useUser.state();
  const router = useRouter();
  const { actions } = useFormState({ updateAccountInfo });

  useEffect(() => {
    if (featureToggles.getRow('ADOBE_ANALYTICS_TRACKING')?.active) {
      const orgType = getOrgType(currentFlow);
      const section1 = 'tin registration';
      const section3 = 'review and confirm';
      const pageName = `digitalsecurity:${section1}:${orgType}:${section3}`;
      setPageHandler('review and confirm');
      adobeTaggingEvent('ON_PAGE_LOAD', {
        pageName,
        orgType,
        organization: TINInfo?.corpName,
        uuid: userUUID,
        tin: TINNumber,
        section1,
        section2: orgType,
        section3,
        siteSectionL3: 'tin registration',
        siteSectionL4: 'healthcare professional or facility',
      });
    }
  }, []);

  const onCancel = () => {
    router.navigate(`/${token}`);
  };
  const REPORTING = 'Reporting';
  const paaInfo = TINInfo ? TINInfo.paaInfo : null;
  const existingUser = !!(
    TINInfo &&
    TINInfo.existingUser &&
    TINInfo.paaInfo &&
    TINInfo.paaInfo.length > 1
  );
  const existingUserWithOnePaa = !!(
    TINInfo &&
    TINInfo.existingUser &&
    TINInfo.paaInfo &&
    TINInfo.paaInfo.length === 1
  );
  const hasReporting =
    selectedPermissions.filter(({ permission }) => {
      return permission === REPORTING;
    }).length >= 1;
  const reportingSubPermissions =
    hasReporting &&
    selectedPermissions.filter(({ permission }) => {
      return permission === REPORTING;
    })[0].subPermissions;

  return (
    <PageLayout style={PagelayoutContainer}>
      <Flex.Content className="Container" style={Container}>
        <HeaderName>
          Review and confirm that your information is correct.
        </HeaderName>
        <Modal
          style={ModalButton}
          isOpen={flyoutModalOpen}
          placement="right"
          showCloseButton={false}
          onClose={() => {
            return setFlyoutModalOpen(false);
          }}
        >
          <Modal.Section>
            <FlyoutCloseButton
              onClick={() => {
                return setFlyoutModalOpen(false);
              }}
            >
              <IconLaunch size={32} color="$gray8" />
            </FlyoutCloseButton>
            <PageLayout style={PagelayoutContainer}>
              <Flex.Content className="Container" style={ModalContainer}>
                <ModalHeaderName>
                  Are you sure you want to cancel?
                </ModalHeaderName>
                <Content>
                  If you cancel, your changes will <b>not</b> be saved
                </Content>
                <ModalButtonView>
                  <ModalBackButton
                    onClick={() => {
                      return changeCurrentStep(-1);
                    }}
                  >
                    <ModalBackButtonText
                      onClick={() => {
                        return setFlyoutModalOpen(false);
                      }}
                    >
                      No, continue
                    </ModalBackButtonText>
                  </ModalBackButton>
                  <ModalNextButton>
                    <ModalNextButtonText onClick={onCancel}>
                      Yes, Cancel
                    </ModalNextButtonText>
                  </ModalNextButton>
                </ModalButtonView>
              </Flex.Content>
            </PageLayout>
          </Modal.Section>
        </Modal>

        <div style={AccountInformation}>
          <SubheaderName>Access Administrator</SubheaderName>
          {paaInfo && paaInfo.length > 1 && (
            <Link
              color="$accent1"
              fontWeight="bold"
              onClick={() => {
                return handleEdit('PAA');
              }}
              aria-label="click here to edit Access Administrator"
            >
              Edit
            </Link>
          )}
        </div>
        <DetailContainer>
          <Flex.Content>
            <TitleHeader>Name</TitleHeader>
            <Name>
              {(selectedAdmin && selectedAdmin.firstName) || '-'}{' '}
              {(selectedAdmin &&
                selectedAdmin.lastName &&
                selectedAdmin.lastName[0]) ||
                '-'}
            </Name>
          </Flex.Content>
        </DetailContainer>

        {!isProviderFlow ||
        (isProviderFlow && !existingUser && !existingUserWithOnePaa) ? (
          <React.Fragment>
            <div style={AccountInformation}>
              <SubheaderName>Account Information</SubheaderName>
              <Link
                color="$accent1"
                fontWeight="bold"
                onClick={() => {
                  actions.updateAccountInfo({
                    phone,
                    phoneExt,
                  });
                  handleEdit('Account Info');
                }}
                aria-label="click here to edit Account Information"
              >
                Edit
              </Link>
            </div>
            <DetailContainer>
              <Flex>
                <Flex.Content space-50>
                  <NameAndNumber>
                    <div>
                      <TitleHeader>Name</TitleHeader>
                      <Name>
                        {' '}
                        {firstName} {lastName}{' '}
                      </Name>
                    </div>
                    <div>
                      <NumberHeader>Work Phone Number</NumberHeader>
                      <EmailPhoneAndJob>
                        {phone} {phoneExt && <Ext> ext.</Ext>}{' '}
                        {phoneExt && phoneExt}
                      </EmailPhoneAndJob>
                    </div>
                  </NameAndNumber>
                </Flex.Content>
                <Flex.Content space-50>
                  <EmailAndJobFunction>
                    <div>
                      <TitleHeader>Email Address</TitleHeader>
                      <Email> {email}</Email>
                    </div>
                    {(isProviderFlow || isSUFlow) &&
                    !existingUser &&
                    !existingUserWithOnePaa ? (
                      <div>
                        <SecondaryTitleHeader>
                          Job Function
                          {Object.keys(selectedJobFunctions).length > 1 && 's'}
                        </SecondaryTitleHeader>
                        <EmailPhoneAndJob>
                          {selectedJobFunctions && (
                            <List>
                              {Object.keys(selectedJobFunctions).map((key) => {
                                return (
                                  <ListItem key={key}>
                                    {selectedJobFunctions[key].name}
                                    {selectedJobFunctions[key].npiValue &&
                                      `, NPI: ${selectedJobFunctions[key].npiValue}`}
                                  </ListItem>
                                );
                              })}
                            </List>
                          )}
                        </EmailPhoneAndJob>
                      </div>
                    ) : null}
                  </EmailAndJobFunction>
                </Flex.Content>
              </Flex>
            </DetailContainer>
          </React.Fragment>
        ) : null}
        {isProviderFlow ? (
          <React.Fragment>
            <div style={AccountInformation}>
              <SubheaderName>Tool Access</SubheaderName>
              <Link
                color="$accent1"
                fontWeight="bold"
                onClick={() => {
                  return handleEdit('Task Access');
                }}
                aria-label="click here to edit Task Access"
              >
                Edit
              </Link>
            </div>
            <TaskAccessDetailContainer>
              {selectedPermissions.length >= 1 ? (
                <TaskAccessContainer>
                  <Flex>
                    <Flex.Content space-100>
                      <div>
                        <TitleHeader>Access</TitleHeader>
                        <List>
                          {selectedPermissions
                            .filter(({ permission }) => {
                              return permission !== REPORTING;
                            })
                            .map(({ permission }) => {
                              return <ListItem>{permission}</ListItem>;
                            })}
                        </List>
                      </div>
                      {hasReporting && (
                        <div>
                          <List>
                            <ListItem>{REPORTING}</ListItem>
                            <ListReporting>
                              {reportingSubPermissions.map(({ name }) => {
                                return (
                                  <ListItemReporting>{name}</ListItemReporting>
                                );
                              })}
                            </ListReporting>
                          </List>
                        </div>
                      )}
                    </Flex.Content>
                  </Flex>
                </TaskAccessContainer>
              ) : (
                <p>None</p>
              )}
            </TaskAccessDetailContainer>
          </React.Fragment>
        ) : null}
      </Flex.Content>
      <Flex.Content>
        <ButtonView>
          <BackButton
            onClick={() => {
              return handleBack();
            }}
          >
            <IconSymbol icon="arrow_back" size={20} color="$primary1" />
            <BackButtonText>Back</BackButtonText>
          </BackButton>
          <NextButton
            onClick={() => {
              return handleConfirm();
            }}
          >
            <NextButtonText>Confirm</NextButtonText>
            <IconSymbol icon="arrow_forward" size={16} color="$primary2" />
          </NextButton>
        </ButtonView>
      </Flex.Content>
    </PageLayout>
  );
};

SUReviewAndConfirm.propTypes = {
  handleEdit: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
};
